module.exports = __webpack_public_path__ + "media/images/pa_wjc_logo-abaa17a5e813e34c60ff49e0cd3a23bd.svg";